import { createLightbox } from '../main/lightbox'

const targetClass = '.j-lightbox__share'
const targetBtn = document.querySelector('.j-open-product-share')
const lightbox = document.querySelector(targetClass)
const shareForm = lightbox.querySelector('form')

const inputPageUrl = document.querySelector('.j-lightbox-share__input-url')
const copyUrl = document.querySelector('.j-lightbox-share__copy-btn')

let lightboxInstance

const _copyPageUrl = (e) => {
	e.preventDefault()
	
	// selezione del contenuto
	inputPageUrl.select()
	// copia negli appunti
	document.execCommand('copy');
	console.log('copiato')
}

const bindEvents = (copyUrl) => {
	copyUrl.addEventListener('click', _copyPageUrl)
}

const init = () => {
	if (targetBtn && lightbox) {
		bindEvents(copyUrl)
		lightboxInstance = createLightbox(targetBtn, targetClass)
	}
}

init()